import { Link } from '@inertiajs/react';

interface Category {
  id: number;
  name: string;
  slug: string;
  description?: string | null;
  image?: string | null;
  product_count: number;
  url: string;
}

interface CategoriesListProps {
  categories: Category[];
  title?: string | null;
  showCount?: boolean;
  className?: string;
}

export default function CategoriesList({
  categories,
  title = 'Categories',
  showCount = true,
  className = '',
}: CategoriesListProps) {
  return (
    <div className={`${className}`}>
      {title && (
        <h2 className="text-2xl font-semibold text-base-content mb-4">
          {title}
        </h2>
      )}
      <div className="flex flex-wrap gap-2">
        {categories.map(category => (
          <Link
            key={category.id}
            href={category.url}
            className="inline-flex items-center space-x-2 px-3 py-1 text-sm font-semibold rounded-full bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
          >
            <span>{category.name}</span>
            {showCount && (
              <span className="text-xs text-blue-700">
                ({category.product_count})
              </span>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
